import { Routes, Route, Navigate } from "react-router-dom";
import { useAdmin } from "../../context/AdminContext";
import Sidebar   from "../../components/admin/Sidebar";
import Dashboard from "./Dashboard";
import Products  from "./Products";
import Orders    from "./Orders";
import Customers from "./Customers";
import Inventory from "./Inventory";
import SEO       from "./SEO";
import Staff from "./Staff";
import Discounts from "./Discounts";
import ShippingSettings from "./ShippingSettings";

function AdminOnlyRoute({ children }) {
  const { admin } = useAdmin();
  if (admin?.role !== "admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}

export default function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-gray-50">
  <Sidebar />
  <main className="flex-1 overflow-auto ml-64">
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products"  element={<Products />} />
          <Route path="orders"    element={<Orders />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="customers" element={<AdminOnlyRoute><Customers /></AdminOnlyRoute>} />
          <Route path="staff" element={<AdminOnlyRoute><Staff /></AdminOnlyRoute>} />
          <Route path="discounts" element={<Discounts />} />
          <Route path="shipping" element={<ShippingSettings />} />
          <Route path="seo"       element={<AdminOnlyRoute><SEO /></AdminOnlyRoute>} />
          <Route index            element={<Navigate to="dashboard" replace />} />
        </Routes>
      </main>
    </div>
  );
}